module.exports = __webpack_public_path__ + "static/media/(V)_MG_4760_-_Cia_Termal_Beachewear_-_Moda_Feminina.d2a05303.jpg";